import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';
import FormModel from "./form/FormModel";
import {Link} from "react-router-dom";

function ContactModal({
                          formationId,
                          sessionId,
                          sessionName,
                          sessionDate,
                          textButton,
                          showText = true,
                          formationName,
                          size = "",
                          linkPageContact,
                          defaultSkin = "btn-style-six",
                          icon = true
}) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
            <>
                {linkPageContact ? (
                    <Link to="/contact"
                        className={`theme-btn ${defaultSkin} ${size} d-flex flex-row justify-content-center align-items-center gap-1`}>
                        {icon && <i className={'cta-icons icon-Info-1'}/>}
                        {textButton}
                    </Link>
                ): (
                    <button
                        className={`theme-btn ${defaultSkin} ${size} d-flex flex-row justify-content-center align-items-center gap-1`}
                         onClick={handleShow}>
                        {icon && <i className={'cta-icons icon-Info-1'}/>}
                        {textButton}
                    </button>)
                }

                <Modal show={show} onHide={handleClose} backdrop={true} centered size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={'d-flex flex-row justify-content-center'}>
                            <span className="shadow-title blue">
                                Contacter Talents Handicap Formation
                            </span>
                        </div>

                        {sessionName && sessionDate && showText && (
                            <div className="sec-title text-center">
                                <div className="text">
                                    <p className={'text-black'}>Vous souhaitez obtenir des renseignements sur la session de formation inter-entreprise :</p>
                                    <span>{sessionName}</span>
                                    <div className="date session-card-schedules">
                                        <i className={'icon-Icone-horloge-cinq'}/>
                                        <strong>{sessionDate}</strong>
                                    </div>
                                    <p className={'text-black'}>Notre équipe est là pour vous accompagner ! Remplissez le formulaire ci-dessous, et nous vous répondrons dans les plus brefs délais.</p>
                                </div>
                            </div>
                        )}
                        {formationId && formationName && (
                            <div className="sec-title text-center">
                                <div className="text">
                                    <p>Vous souhaitez obtenir des renseignements sur la formation:</p>
                                    <span>{formationName}</span>
                                    <p>Notre équipe est là pour vous accompagner ! Remplissez le formulaire ci-dessous,
                                        et nous vous répondrons dans les plus brefs délais.</p>
                                </div>
                            </div>
                        )}

                        <div className="default-form">
                            <FormModel handleClose={handleClose} formationId={formationId} sessionId={sessionId} type={2}/>
                        </div>

                    </Modal.Body>
                </Modal>
            </>
    );
}

export default ContactModal;